import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoaderProps {
  fullScreen?: boolean;
  size?: number;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';
}

const Loader: React.FC<LoaderProps> = ({ 
  fullScreen = false, 
  size = 40, 
  color = 'primary' 
}) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
        }}
      >
        <CircularProgress size={size} color={color} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 2,
      }}
    >
      <CircularProgress size={size} color={color} />
    </Box>
  );
};

export default Loader; 